import { useAttributionOpportunitiesTrend } from '@/api/attribution';
import { type DashboardWidgetComponentProps } from '@/components/Dashboard/types';
import { OpportunityInfluenceChart } from '@/features/OpportunityInfluenceChartTableCombo';

const OpportunityInfluenceTrendWidget = ({ pageFilters }: DashboardWidgetComponentProps) => {
  const { startDate, endDate, audience } = pageFilters;
  const { attributionTrend, isLoading, error } = useAttributionOpportunitiesTrend(
    startDate,
    endDate,
    audience?.id,
  );

  return (
    <OpportunityInfluenceChart
      opportunityType="pipeline"
      data={attributionTrend}
      isLoading={isLoading}
      error={error}
    />
  );
};

export default OpportunityInfluenceTrendWidget;
